import { withInterstitial } from 'wanderu-component-page-loader';
import { ScrollToTopOnMount } from 'wanderu-hocs';

import {
    DEPART_DIRECTION,
    RETURN_DIRECTION,
} from './constants';

const UniversalSearchContent = withInterstitial(import('./containers/SearchContent'));

const SearchPage = withInterstitial(import('./pages/Search'), {
    onLoad(module, ...args) {
        module.onLoad(module, ...args);
    },
});

const DIRECTIONS = [
    DEPART_DIRECTION,
    RETURN_DIRECTION,
];

const routes = [
    {
        component: ScrollToTopOnMount(SearchPage),
        key: 'search',
        path: `/:direction(${DIRECTIONS.join('|')})/:originText/:destinationText/:departDate?/:returnDate?/`,
        routes: [
            {
                component: ScrollToTopOnMount(UniversalSearchContent),
                key: 'searchDepart',
                path: '/:direction/:originText/:destinationText/:departDate/:returnDate?/',
            },
        ],
    },
];

export default routes;
